export default __webpack_public_path__ + "static/media/bg.5e39e6b1.jpg";